import React from 'react';

/**
 * White card wrapper for a page section, matching the app's CLP-derived
 * card design (icon chip + title + subtitle) used by DataTableCard.
 * Unlike DataTableCard, actions live inline next to the title so it fits
 * dashboard-style sections that don't need a filter toolbar.
 */
const SectionCard = ({
  id,
  icon,
  iconColor = 'primary',
  eyebrow,
  title,
  subtitle,
  actions,
  children,
}) => {
  return (
    <section
      id={id}
      className="card card-body border-0 shadow-sm rounded-4 mb-4"
      style={{ scrollMarginTop: '84px' }}
    >
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-4">
        <div className="d-flex align-items-center gap-3">
          {icon && (
            <div
              className={`bg-${iconColor} bg-opacity-10 d-flex align-items-center justify-content-center rounded-3 flex-shrink-0`}
              style={{ width: '40px', height: '40px' }}
            >
              <i className={`bi ${icon} text-${iconColor} fs-5`}></i>
            </div>
          )}
          <div>
            {eyebrow && (
              <div
                className="fw-bold text-uppercase text-muted"
                style={{ fontSize: '0.65rem', letterSpacing: '0.6px' }}
              >
                {eyebrow}
              </div>
            )}
            <h2 className="h5 fw-bold mb-0 text-dark lh-sm">{title}</h2>
            {subtitle && (
              <p className="text-muted mb-0" style={{ fontSize: '0.75rem' }}>
                {subtitle}
              </p>
            )}
          </div>
        </div>
        {actions && <div className="d-flex align-items-center gap-2">{actions}</div>}
      </div>

      {children}
    </section>
  );
};

export default SectionCard;
